import type { PasswordResetChallenge } from "@/lib/api";

const PASSWORD_RESET_STORAGE_KEY = "gupio_portal_pending_password_reset";

export interface PendingPasswordResetState {
  challenge: PasswordResetChallenge;
  resetToken?: string;
}

export function clearPendingPasswordResetState() {
  window.sessionStorage.removeItem(PASSWORD_RESET_STORAGE_KEY);
}

export function readPendingPasswordResetState() {
  const raw = window.sessionStorage.getItem(PASSWORD_RESET_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as PendingPasswordResetState;
  } catch {
    clearPendingPasswordResetState();
    return null;
  }
}

export function savePendingPasswordResetState(state: PendingPasswordResetState) {
  window.sessionStorage.setItem(PASSWORD_RESET_STORAGE_KEY, JSON.stringify(state));
}
